module.exports = __webpack_public_path__ + "img/playground.c4ee5905.png";